// src/components/BarChart.js
import React from "react";
import Chart from "react-apexcharts";

const BarChart = ({ data }) => {
  // Pad data to minimum 3 items for consistent appearance
  const minBars = 3;
  const paddedData = {
    labels: [...data.labels],
    values: [...data.values],
  };

  // Add empty bars if needed
  while (paddedData.labels.length < minBars) {
    paddedData.labels.push("");
    paddedData.values.push(0);
  }

  const options = {
    chart: {
      type: "bar",
      height: 650, // Set the desired height here
      width: 1200, // Overall chart width
      toolbar: {
        show: false, // Disable the menu
      },
    },
    xaxis: {
      categories: paddedData.labels,
      labels: {
        style: {
          fontWeight: "700",
          fontSize: "25px", // Increase font size for platform labels
          colors: "#007bff", // Set color for platform labels
        },
      },
    },
    yaxis: {
      title: {
        text: "Counts", // Add the y-axis title
        style: {
          fontWeight: "bold",
          fontSize: "25px", // Increase font size for y-axis title
          color: "#007bff", // Set color for y-axis title
        },
      },
      labels: {
        style: {
          fontWeight: "600",
          fontSize: "20px", // Increase font size for y-axis labels
          color: "#333", // Set color for y-axis labels
        },
      },
    },
    legend: {
      show: false, // Disable the legend
    },
    plotOptions: {
      bar: {
        distributed: true, // Color each bar differently
        barHeight: "50%", // Reduce the width of individual bars
        columnWidth: "50%", // Adjust column width for further bar width reduction
      },
    },
    dataLabels: {
      enabled: false, // Disable data labels on bars
    },
  };

  const series = [
    {
      name: "Counts",
      data: paddedData.values,
    },
  ];

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      height={650}
      width={1200}
    />
  );
};

export default BarChart;
